'use strict';

const Backbone = require('backbone');
const Moment = require('moment');
const AnnouncementModel = require('../entity/announcement');

class AnnouncementCollection extends Backbone.Collection {
    static get model() {
        return AnnouncementModel;
    }

    constructor(models, options) {
        super(models, options);

        this._repository = options.repository;
        this._sortKey = options && options.sortKey || 'createdAt';

        this._firstFetched = false;
        this._totalCount = 0;
        this._nextCursor = null;
        this._nextMore = false;

        this.listenTo(this._repository, 'add', announcement => {
            this.add(announcement);
        });
        this.listenTo(this._repository, 'update', announcement => {
            this.add(announcement, {merge: true});
        })
    }

    comparator(model) {
        const value = model.get(this._sortKey);
        if (value) {
            return - Moment(value).unix();
        } else {
            return - model.getID();
        }
    }

    fetchFirstPage(limit=10) {
        if (this._firstFetched) {
            return new Promise((resolve, reject) => {
                resolve(this);
            });
        }

        return this._fetch(limit, null)
            .then(result => {
                this.add(result.models, {merge: true});
                this._totalCount = result.pagination.totalCount;
                this._nextCursor = result.pagination.nextCursor;
                this._nextMore = result.pagination.more;

                this._firstFetched = true;
                return this;
            });
    }

    _fetch(limit, cursor) {
        return this._repository.fetch(limit, cursor);
    }

    fetchMore(limit=10) {
        if (! this._nextMore) {
            return new Promise((resolve, reject) => {
                resolve(this);
            });
        }

        return this._fetch(limit, this._nextCursor)
            .then(result => {
                this.add(result.models, {merge: true});
                this._totalCount = result.pagination.totalCount;
                this._nextCursor = result.pagination.nextCursor;
                this._nextMore = result.pagination.nextMore;

                return this;
            });
    }
}

module.exports = AnnouncementCollection;



// WEBPACK FOOTER //
// ./feedback/domain/collection/announcement.js